import React from "react";
import "../../../../../css/pages/ca_pages/teams/teams_model/DashboardWorkingEmployees.css";

const getStatusConfig = (status) => {
    switch (status) {
        case "working":
            return { label: "Working", color: "#16a34a" };

        case "available":
            return { label: "Available", color: "#2563eb" };

        case "break":
            return { label: "On Break", color: "#ea580c" };

        case "offline":
        default:
            return { label: "Offline", color: "#64748b" };
    }
};

const formatDuration = (startedAt) => {
    if (!startedAt) { return "--"; }

    const start = new Date(startedAt);
    const now = new Date();

    const diffMs = Math.max(0, now - start);

    const totalMinutes = Math.floor(diffMs / 60000);

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    if (hours > 0) { return `${hours}h ${minutes}m`; }

    return `${minutes}m`;
};

const DashboardWorkingEmployees = ({ employees = [] }) => {
    return (
        <div className="working-card">
            <div className="working-header">
                <div>
                    <h2>Working Right Now</h2>
                    <p>Current employee activity.</p>
                </div>

                <button>
                    View Team
                </button>
            </div>

            <div className="working-list">
                {employees.length === 0 ? (
                    <div
                        style={{
                            padding: "20px",
                            textAlign: "center",
                            color: "#64748b",
                        }}
                    >
                        No employee activity available.
                    </div>
                ) : (
                    employees.map((employee) => {
                        const status = getStatusConfig(employee.status);

                        const task =
                            employee.current_task?.title ||
                            (
                                employee.status === "available"
                                    ? "Waiting for Assignment"
                                    : employee.status === "offline"
                                        ? "Offline"
                                        : "No active task"
                            );

                        return (
                            <div
                                key={employee.id}
                                className="working-item"
                            >
                                <div
                                    className="working-avatar"
                                    style={{
                                        background: `${status.color}20`,
                                        color: status.color,
                                    }}
                                >
                                    {employee.name
                                        ?.charAt(0)
                                        ?.toUpperCase() || "?"}
                                </div>

                                <div className="working-info">
                                    <div className="working-name">
                                        {employee.name}
                                    </div>

                                    <div className="working-task">
                                        {task}
                                    </div>
                                </div>

                                <div className="working-right">
                                    <div
                                        className="working-status"
                                        style={{ color: status.color }}
                                    >
                                        ● {status.label}
                                    </div>

                                    <div className="working-duration">
                                        {employee.status === "working"
                                            ? formatDuration(employee.started_at)
                                            : "--"}
                                    </div>
                                </div>
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    );
};

export default DashboardWorkingEmployees;
